<template>
  <div class="problem-lside">
    <ul>
      <li>
        <a href="javascript:void(0);" class="nli">{{ $t('personalInfo.personalCenter') }}<b class="arrow"></b></a>
        <ul class="ulson" style="display: block;">
          <li><router-link to="/pages/platform/personalCenter">{{ $t('personalInfo.orderManage') }}</router-link></li>
          <li><router-link to="/pages/platform/cart">{{ $t('personalInfo.shoppingCart') }}</router-link></li>
          <li><router-link to="/pages/platform/address">{{ $t('personalInfo.deliveryAddress') }}</router-link></li>
          <li><router-link to="/pages/platform/personalInfo">{{ $t('personalInfo.personalInfo') }}</router-link></li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PersonalInfoSidebar'
}
</script>

<style scoped>
.problem-lside {
  width: 200px;
  background: #fff;
  padding: 20px 0;
}
.nli {
  display: block;
  padding: 10px 20px;
  color: #333;
  font-weight: bold;
  border-left: 3px solid transparent;
}
.nli:hover {
  color: #409EFF;
}
.ulson {
  padding-left: 20px;
}
.ulson li a {
  display: block;
  padding: 8px 20px;
  color: #666;
}
.ulson li a:hover,
.ulson li a.router-link-active {
  color: #409EFF;
}
.arrow {
  float: right;
  margin-top: 5px;
  border-top: 5px solid #999;
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
}
</style>